import CustomerForm from './components/CustomerForm/CustomerForm.vue'
import ContactForm from './components/ContactForm/ContactForm.vue'

const modals: KwixeoInterface.DynamicModals = [
  {
    key: 'customer-form',
    title: customer => customer && customer.id ? 'customers.customer.editTitle' : 'customers.customer.addTitle',
    component: CustomerForm,
    size: 'xl',
    attributes: {
      type: 'customer'
    }
  },
  {
    key: 'provider-form',
    title: customer => customer && customer.id ? 'customers.provider.editTitle' : 'customers.provider.addTitle',
    component: CustomerForm,
    size: 'xl',
    attributes: {
      type: 'provider'
    }
  },
  {
    key: 'contact-form',
    title: contact => contact && contact.id ? 'customers.contact.editTitle' : 'customers.contact.addTitle',
    component: ContactForm,
    size: 'xl'
  },
  {
    key: 'prospect-form',
    title: customer => customer && customer.id ? 'customers.prospect.editTitle' : 'customers.prospect.addTitle',
    component: CustomerForm,
    size: 'xl',
    attributes: {
      type: 'prospect'
    }
  },
  {
    key: 'subcontractor-form',
    title: customer => customer && customer.id ? 'customers.subcontractor.editTitle' : 'customers.subcontractor.addTitle',
    component: CustomerForm,
    size: 'xl',
    attributes: {
      type: 'subcontractor'
    }
  }
]

export default modals
